<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="title"
      width="1160px"
      :close-on-click-modal="false"
      append-to-body
      class="app-main-inner copy-charge-dialog"
    >
      <div class="app-main-inner-row">
        <el-form
          label-width="80px"
          label-position="left"
        >
          <el-row :gutter="10">
            <!--业务编号-->
            <el-col :span="6">
              <el-form-item>
                <line-label slot="label" :label="$t('CargoMsg.Cargo_BusinessNo')" />
                <el-input v-model="form.jobNo" />
              </el-form-item>
            </el-col>
            <!--委托单位-->
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_AuthorizedClient')">
                <cargo-sales-company-select
                  options-width="150px;"
                  :method-params="{customer:true}"
                  :default-value="form.customer == 0 ? '': form.customer"
                  @parentCallBack="p=>form.customer=p.cmpIdx"
                />
              </el-form-item>
            </el-col>
            <!--整拼类型 -->
            <el-col :span="6">
              <el-form-item>
                <line-label slot="label" :label="$t('CargoMsg.Cargo_FLCLType')" />
                <el-select
                  v-model="form.containerLoadType"
                >
                  <el-option
                    v-for="(item,index) in containerLoadTypes"
                    :key="index"
                    :label="isZh?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 货物类型-->
            <el-col :span="6">
              <el-form-item>
                <line-label slot="label" :label="$t('CargoMsg.Cargo_CargoType')" />
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_CargoType"
                  callback-method-type="value"
                  :default-value="form.cargoType"
                  :callback-params="{key:'cargoType'}"
                  options-width="150px;"
                  @parentCallBack="p=>{form.cargoType=p.value}"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <!--            主单号-->
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_MblNo')">
                <el-input v-model="form.mblNo" />
              </el-form-item>
            </el-col>
            <!--订舱代理-->
            <el-col :span="6">
              <el-form-item>
                <line-label slot="label" :label="$t('CargoMsg.Cargo_BookingAgent')" />
                <cargo-advance-select
                  filterable
                  options-width="150px;"
                  :method-params="{bookingAgent:true}"
                  :select-type="selectTypeNames.basic_data_Company"
                  :default-value="form.bookingAgent == 0 ? '': form.bookingAgent"
                  @parentCallBack="p=>form.bookingAgent=p.cmpIdx"
                />
              </el-form-item>
            </el-col>
            <!-- 起运港-->
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.PortOfLoading')">
                <cargo-advance-select
                  v-show="isSea"
                  options-width="150px;"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="form.txtSeaLoadingPort"
                  tag-name="englishName"
                  @parentCallBack="p=>{form.txtSeaLoadingPort=p.code}"
                />

                <cargo-advance-select
                  v-show="!isSea"
                  :select-type="selectTypeNames.basic_data_Airport"
                  filterable
                  options-width="150px;"
                  :default-value="form.txtAirLoadingPort"
                  tag-name="englishName"
                  @parentCallBack="p=>{form.txtAirLoadingPort=p.code}"
                />
              </el-form-item>
            </el-col>
            <!--            目的港-->
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_DestinationPort')">
                <cargo-advance-select
                  v-show="isSea"
                  options-width="150px;"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="form.txtSeaDestinationPort"
                  tag-name="englishName"
                  @parentCallBack="p=>{form.txtSeaDestinationPort=p.code}"
                />

                <cargo-advance-select
                  v-show="!isSea"
                  options-width="150px;"
                  :select-type="selectTypeNames.basic_data_Airport"
                  filterable
                  :default-value="form.txtAirDestinationPort"
                  tag-name="englishName"
                  @parentCallBack="p=>{form.txtAirDestinationPort=p.code}"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <!--            承运人-->
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_Carrier')">
                <cargo-advance-select
                  v-show="isSea"
                  filterable
                  options-width="150px;"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{seaCmp:true}"
                  :default-value="form.seCarrier == 0 ? '': form.seCarrier"
                  @parentCallBack="p=>form.seCarrier=p.cmpIdx"
                />
                <cargo-advance-select
                  v-show="!isSea"
                  filterable
                  options-width="150px;"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{seaCmp:true}"
                  :default-value="form.aiCarrier == 0 ? '': form.aiCarrier"
                  @parentCallBack="p=>form.aiCarrier=p.cmpIdx"
                />
              </el-form-item>
            </el-col>
            <!--            费用名称-->
            <el-col :span="6">
              <el-form-item :label="$t('FinanceManage.charge_chargeItem')" label-position="right">
                <cargo-advance-select
                  filterable
                  options-width="150px;"
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  :default-value="form.chargeItemId == 0 ? '': form.chargeItemId"
                  @parentCallBack="p=>form.chargeItemId=p.itemId"
                />
              </el-form-item>
            </el-col>
            <!--            航线-->
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_Airline')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Region"
                  :callback-params="{key:'txtServiceLine'}"
                  callback-method-type="value"
                  options-width="150px;"
                  :default-value="form.txtServiceLine"
                  @parentCallBack="p=>form.txtServiceLine=p.value"
                />
              </el-form-item>
            </el-col>
            <!--            目的港代理-->
            <el-col :span="6">
              <el-form-item>
                <line-label slot="label" :label="$t('CargoMsg.Cargo_DestinationAgent')" />
                <cargo-advance-select
                  filterable
                  tag-name="englishName"
                  options-width="150px;"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{overseaAgent:true}"
                  :default-value="form.txtDestAgent"
                  @parentCallBack="p=>form.txtDestAgent=p.cmpIdx"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <!--              收付款-->
            <el-col :span="6">
              <el-form-item>
                <line-label slot="label" :label="$t('CargoMsg.Cargo_PaymentReceiveMethod')" />
                <el-select v-model="form.receivable" filterable clearable style="width: 100%" :disabled="receivableDisable">
                  <el-option v-for="(item,index) in CHANGE_CHARGE_CHARGETYPE" :key="index" :label="item.chineseName" :value="item.code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_SettleAccountsTo')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{active:true}"
                  :default-value="form.accountId"
                  @parentCallBack="p=>{form.accountId=p.value}"
                />
              </el-form-item>
            </el-col>
            <template v-if="isSeaOrRailwayOrIntegrated">
              <el-col :span="6">
                <el-form-item>
                  <line-label slot="label" :label="$t('CargoMsg.Cargo_ContainerSize')" />
                  <el-select v-model="form.eqSize" filterable clearable style="width: 100%">
                    <el-option v-for="(item,index) in SEA_EXPORT_BOX_TYPES" :key="index" :label="item.chineseName" :value="item.code" :default-value="form.eqSize" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('CargoMsg.Cargo_ContainerType')">
                  <cargo-advance-select
                    filterable
                    :select-type="selectTypeNames.basic_data_EQType"
                    tag-name="code"
                    :method-params="{active:true}"
                    :default-value="form.eqType"
                    @parentCallBack="p=>{form.eqType=p.value}"
                  />
                </el-form-item>
              </el-col>
            </template>
          </el-row>
          <el-row :gutter="10">
            <template v-if="isSeaOrAir">
              <el-col :span="6">
                <el-form-item :label="$t('CargoMsg.Cargo_MBLFreightTerm')">
                  <cargo-advance-select
                    filterable
                    :select-type="selectTypeNames.basic_data_PaymentTerm"
                    :method-params="{active:true}"
                    :default-value="form.paymentTermMBL"
                    @parentCallBack="p=>{form.paymentTermMBL=p.value}"
                  />
                </el-form-item>
              </el-col>
            </template>
            <template v-if="isZY">
              <el-col :span="6">
                <el-form-item :label="$t('SeaExport.AllowSaleProduct')">
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_AllowSaleProduct"
                    filterable
                    no="allowSaleProduct"
                    :method-params="{saleProductCode:true}"
                    :data-filter-function="p => p.statusEnabled"
                    :default-value="form.saleProductCode || ''"
                    @parentCallBack="p => {form.saleProductCode = p.value}"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('SeaExport.FullOrInside')">
                  <cargo-advance-select
                    :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
                    no="fullOrInside"
                    :method-params="{fullOrInside:true}"
                    :default-value="form.fullOrInside || ''"
                    @parentCallBack="p => {form.fullOrInside = p.value}"
                  />
                </el-form-item>
              </el-col>
            </template>
            <el-col :span="6">
              <el-form-item>
                <line-label slot="label" :label="$t('SeaExport.ItemNo')" />
                <el-input v-model="form.poNo" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item
                class="custom"
              >
                <el-button
                  type="primary"
                  @click="toQuery(1)"
                >{{ $t('common.btn.query') }}</el-button>
                <el-button
                  type="primary"
                  @click="resetHandler"
                >{{ $t('CargoMsg.Cargo_ResetFilter') }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div
        class="app-main-inner-row row-grid"
        style="min-height:350px;padding:0"
      >
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :deselect-sub-record="true"
          style="width:100%;height: 400px;"
          @gridReady="onGridReady"
        />
      </div>
      <cargo-pagination
        :page-sizes="[5, 10, 20, 30, 50, 500]"
        config-module="9300001"
        :total="searchConditions.total"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
      <span
        slot="footer"
        style="padding:10px"
      >
        <el-button
          type="primary"
          @click="selectHandler"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import ColumnUtils from '@/utils/ColumnUtils'
import { copyChargeSelector } from '@/api/clearing/charge'
import { getLoading } from '@/utils/utilBaseElement'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { CHANGE_CHARGE_CHARGETYPE } from '@/class/cargo/model/parameters/ChangeChargeConstant'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import { getObjectByCache } from '@/utils/basicDataCache'
import { cache, cacheName } from '@/utils/cacheManager'
import { SEA_EXPORT_BOX_TYPES, STUFFY_TT } from '@/class/cargo/model/parameters/SeaExportConstants'

export default {
  name: 'CopyChargeDialog',
  components: { CargoAdvanceSelect, CargoSalesCompanySelect },
  props: {
    visible: { type: Boolean, required: true },
    isSea: { type: Boolean, required: true, default: () => false },
    lob: { type: String, required: true, default: () => '' },
    job: { type: Object, required: false },
    receivable: { type: Number, required: false },
    receivableDisable: { type: Boolean, required: false, default: () => false },
    viewSource: { type: String, required: false, default: '' }
  },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      MAX_COUNT: 5000,
      selectTypeNames: TYPE_NAMES,
      CHANGE_CHARGE_CHARGETYPE,
      SEA_EXPORT_BOX_TYPES,
      innerVisible: false,
      title: this.$t('FinanceManage.charge_copyCharge'),
      searchConditions: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 30,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        treeData: true,
        groupDefaultExpanded: 0,
        getDataPath: (data) => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('CargoMsg.Cargo_BusinessNoAndChargeName'),
          field: 'name',
          width: 200,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: (params) => {
              return true
            }
          }
        },
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        },
        onRowSelected: this.treeDataRowSelectedCallBack
      },
      containerLoadTypes: ContainerLoadType.CONTAINERLOAD_TYPES,
      form: {
        chargeItemId: '',
        customer: 0,
        bookingAgent: 0,
        seCarrier: 0,
        aiCarrier: 0,
        containerLoadType: '',
        cargoType: '',
        txtSeaLoadingPort: '',
        txtAirLoadingPort: '',
        txtSeaDestinationPort: '',
        txtAirDestinationPort: '',
        txtDestAgent: '',
        txtServiceLine: '',
        jobNo: '',
        receivable: '',
        limit: 30,
        // 主单号
        mblNo: '',
        accountId: 0,
        saleProductCode: '',
        fullOrInside: 0,
        // 箱型
        eqSize: '',
        // 箱种
        eqType: '',
        // 运费条款
        paymentTermMBL: '',
        // 项目编号
        poNo: ''
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_MblNo'),
          field: 'mblNo',
          width: 180
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'),
          field: 'accountId',
          width: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayReceive'),
          field: 'receivable',
          width: 180,
          valueFormatter: (params) => {
            if (params.data['parentUuid'] === '') return ''
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_somesticOrInternational'),
          field: 'oversea',
          width: 180,
          valueFormatter: (params) => {
            if (params.data['parentUuid'] === '') return ''
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'currency',
          width: 120
        },
        {
          headerName: this.$t('FinanceManage.charge_unit'),
          field: 'measure',
          width: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_quantity'),
          field: 'quantity',
          width: 180,
          valueFormatter: (params) => {
            if (params.data['parentUuid'] === '') return ''
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPrice'),
          field: 'unitRate',
          width: 180,
          valueFormatter: (params) => {
            if (params.data['parentUuid'] === '') return ''
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxIncludedPrice'),
          field: 'amount',
          width: 180,
          valueFormatter: (params) => {
            if (params.data['parentUuid'] === '') return ''
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxExcludedPrice'),
          field: 'excludingTaxAmount',
          width: 180,
          valueFormatter: (params) => {
            if (params.data['parentUuid'] === '') return ''
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxRate'),
          field: 'taxRate', width: 180,
          valueFormatter: (params) => {
            if (params.data['parentUuid'] === '') return ''
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxAmount'),
          field: 'taxAmount', width: 180,
          valueFormatter: (params) => {
            if (params.data['parentUuid'] === '') return ''
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContainerDescription'),
          field: 'containerDesc',
          width: 180,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_MBLFreightTerm'),
          field: 'paymentTermMBL',
          cellRenderer: (params) => {
            return ColumnUtils.paymentTermLabelFunc(params.value)
          },
          width: 180,
          hide: true
        }
      ],
      rowData: [],
      gridApi: null,
      isZY: false,
      // CARGO-46035 海运出口、海运进口、铁路业务、综合物流-集卡托车 展示箱型 箱种下拉框
      isSeaOrRailwayOrIntegrated: false,
      copyChargeOnlySelf: this.$checkPermission(['role_Charge_copyChargeOnlySelf']), // 抄录费用查看自己的费用权限
      // CARGO-46035 海运出口、海运进口、空运进口、空运出口 展示主单运费条款
      isSeaOrAir: false
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (newVal) {
        this.initCondition()
      } else {
        this.rowData = []
        this.$emit('update:visible', newVal)
      }
    }
  },
  async created() {
    if (this.visible) {
      this.innerVisible = this.visible
      this.initCondition()
    }
  },
  methods: {
    treeDataRowSelectedCallBack(p) {
      if (p.data.root) {
        if (p.node.selected) {
          p.node.childrenAfterGroup.forEach((node) => {
            node.setSelected(p.node.selected)
          })
        } else {
          const isTrue = p.node.childrenAfterGroup.filter(
            (node) => node.selected
          )
          if (isTrue.length === p.node.childrenAfterGroup.length) {
            p.node.childrenAfterGroup.forEach((node) => {
              node.setSelected(p.node.selected)
            })
          }
        }
      } else {
        if (!p.node.selected) {
          if (p.node.parent.selected) {
            p.node.parent.setSelected(false)
          }
        } else {
          const brothers = p.node.parent.childrenAfterGroup
          const selected = brothers.filter((node) => node.selected)
          if (selected.length === brothers.length) {
            p.node.parent.setSelected(true)
          }
        }
      }
    },
    getValueFromChild(obj) {
      if (!obj || !obj.value) return
      this.form[obj.key] = obj.value
    },
    getCargoType() {
      if (this.lob === 'SE') {
        this.containerLoadTypes = ContainerLoadType.CONTAINERLOAD_TYPES
      } else if (this.lob === 'SI') {
        this.containerLoadTypes = ImportConstants._cargoTypeInputList
      } else if (this.lob === 'AE' || this.lob === 'AI') {
        this.containerLoadTypes = AirExportConstants.BUSINESS_MODELS
      }
    },
    async initCondition() {
      await cache.load(cacheName.CONFIG)
      this.isZY = String(cache.config.get('ToExoSystem')) === 'zy' // 显示中邮选项
      this.getCargoType()
      this.form.containerLoadType = this.selectedContainerLoadType() || (this.job.lob === 'SE' ? 'FCL' : '') // flex中整拼类型的控件默认第一个 / FCL
      this.form.txtSeaLoadingPort = this.job.loadingPortCode
      this.form.txtAirLoadingPort = this.job.loadingPortCode
      this.form.txtSeaDestinationPort = this.job.dischargingPortCode
      this.form.txtAirDestinationPort = this.job.dischargingPortCode
      this.form.txtDestAgent = this.job.destinationAgent
      this.form.cargoType = this.job.cargoType
      this.title = this.$t('FinanceManage.charge_copyCharge')
      // CARGO-46035 箱种、箱型需要的lob
      this.isSeaOrRailwayOrIntegrated = ['SE', 'SI', 'RE', 'RI'].includes(this.job.lob) || this.job.containerLoadType === STUFFY_TT.code
      // CARGO-46035 运费条款需要的lob
      this.isSeaOrAir = ['SE', 'SI', 'AE', 'AI'].includes(this.job.lob)
      this.initHandler()
      this.toQuery()
    },
    selectedContainerLoadType() {
      let loadType = ''
      if (!this.job) return loadType
      if (
        this.job.lob === 'SE' ||
        this.job.lob === 'SI' ||
        this.job.lob === 'RE' ||
        this.job.lob === 'RI'
      ) {
        loadType = this.job.containerLoadType
      } else {
        loadType = this.job.operateType
      }
      return loadType
    },
    toQuery(pageNum) {
      const map = {}
      map['lob'] = this.lob
      if (this.form.chargeItemId !== '') {
        map['chargeItemId'] = this.form.chargeItemId
      }
      if (this.form.customer > 0) {
        map['customerId'] = this.form.customer
      }
      if (this.isSea) {
        if (this.form.seCarrier > 0) {
          map['carrierId'] = this.form.seCarrier
        }
        if (this.form.txtSeaLoadingPort !== '') {
          map['loadingPort'] = this.form.txtSeaLoadingPort
        }
        if (this.form.txtSeaDestinationPort !== '') {
          map['destinationPort'] = this.form.txtSeaDestinationPort
        }
      } else {
        if (this.form.aiCarrier > 0) {
          map['carrierId'] = this.form.aiCarrier
        }
        if (this.form.txtAirLoadingPort !== '') {
          map['loadingPort'] = this.form.txtAirLoadingPort
        }
        if (this.form.txtAirDestinationPort !== '') {
          map['destinationPort'] = this.form.txtAirDestinationPort
        }
      }
      if (this.form.txtDestAgent > 0) {
        map['destAgent'] = this.form.txtDestAgent
      }
      if (this.form.bookingAgent > 0) {
        map['bookingAgent'] = this.form.bookingAgent
      }
      if (this.form.cargoType !== '' && this.form.cargoType !== 'All') {
        map['cargoType'] = this.form.cargoType
      }
      if (this.form.containerLoadType !== '') {
        map['containerLoadType'] = this.form.containerLoadType
      }
      if (this.form.txtServiceLine !== '') {
        map['region'] = this.form.txtServiceLine
      }
      if (this.form.jobNo !== '') {
        map['jobNo'] = this.form.jobNo
      }
      if (this.form.receivable !== '') {
        map['receivable'] = this.form.receivable
      }
      // 主单号
      if (this.form.mblNo !== '') {
        map['mblNo'] = this.form.mblNo
      }
      // 结算对象
      if (this.form.accountId > 0) {
        map['accountId'] = this.form.accountId
      }
      map['branchId'] = this.$store.getters.currentOfficeId
      // map['limit'] = this.form.limit > 0 ? this.form.limit : 30
      // 是否是中邮
      if (this.isZY) {
        if (this.form.saleProductCode !== '') {
          map['saleProductCode'] = this.form.saleProductCode
        }
        if (this.form.fullOrInside > 0) {
          map['fullOrInside'] = this.form.fullOrInside
        }
      }
      if (this.isSeaOrRailwayOrIntegrated) {
        // 箱型
        if (this.form.eqSize !== '') {
          map['eqSize'] = this.form.eqSize
        }
        // 箱种
        if (this.form.eqType !== '') {
          map['eqType'] = this.form.eqType
        }
      }
      if (this.isSeaOrAir) {
        // 主单运费条款
        if (this.form.paymentTermMBL !== '') {
          map['paymentTermMBL'] = this.form.paymentTermMBL
        }
      }
      if (this.copyChargeOnlySelf && !this.$store.getters.isAdmin) {
        map['createdBy'] = this.$store.getters.userId
      }
      if (this.form.poNo !== '') {
        map['poNo'] = this.form.poNo
      }
      map['pageNum'] = pageNum || this.searchConditions.pageNum
      map['pageSize'] = this.searchConditions.pageSize ? this.searchConditions.pageSize : 30

      this.loading = getLoading()
      copyChargeSelector(map).then((res) =>
        this.copyChargeSelectorResult(res)
      ).finally(() => {
        this.loading.close()
      })
    },
    fetchDataByPage() {
      this.toQuery()
    },
    onGridReady(params) {
      this.gridApi = params.api
    },
    copyChargeSelectorResult(res) {
      this.rowData = res.data.list
      this.searchConditions.total = Number(res.data.total)
      this.searchConditions.pageNum = res.data.pageNum
      this.searchConditions.pageSize = res.data.pageSize
      this.gridApi.clearFocusedCell()
    },
    selectHandler() {
      let chargeList = this.getSelectItems()
      if (chargeList.length === 0) {
        this.$message.info(this.$t('Message.PleaseSelect1ChargeDetail'))
        return
      }

      // 销售查询页面：使用新的权限校验逻辑（支持特殊费用）
      if (this.viewSource !== 'salesDetail') {
        // 非销售查询页面：使用旧的权限校验逻辑
        const length = chargeList.length
        let havePayCharge = false
        let haveCostCharge = false
        // receivable: true应收 false应付;
        if (!this.$checkPermission(['button_Charge_payAddCharge']) && this.$checkPermission(['button_Charge_costAddCharge'])) {
          // 有应付费用新增权限 没有应收费用新增权限 去除应收费用
          chargeList = chargeList.filter(charge => !charge.receivable)
          havePayCharge = chargeList.length !== length
          if (chargeList.length === 0) {
            this.$message.warning(this.$t('Message.NoPayChargesImport'))
            return
          }
          if (havePayCharge) {
            this.$message.warning(this.$t('Message.OnlyCostChargesImport'))
          }
        }
        if (!this.$checkPermission(['button_Charge_costAddCharge']) && this.$checkPermission(['button_Charge_payAddCharge'])) {
          // 有应收费用新增权限 没有应付费用新增权限去除应付费用
          chargeList = chargeList.filter(charge => charge.receivable)
          haveCostCharge = chargeList.length !== length
          if (chargeList.length === 0) {
            this.$message.warning(this.$t('Message.NoCostChargesImport'))
            return
          }
          if (haveCostCharge) {
            this.$message.warning(this.$t('Message.OnlyPayChargesImport'))
          }
        }
      }

      for (const charge of chargeList) {
        if (charge.accountId > 0) {
          const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', charge.accountId)
          if (charge.receivable) {
            if (!company.ifCustomer) {
              this.$message.warning(this.$t('Message.ThisPartnerDoesNotSupportEnterReceivableFees'))
              return
            }
          } else {
            if (!company.ifSupplier) {
              this.$message.warning(this.$t('Message.ThisPartnerDoesNotSupportEnterPayableFees'))
              return
            }
          }
        }
      }

      // 销售查询页面：校验应收和应付费用新增权限
      if (this.viewSource === 'salesDetail') {
        const isAdmin = this.$store.getters.isAdmin || this.$store.getters.admin

        // 非管理员需要进行权限校验
        if (!isAdmin) {
          // 获取权限状态（costAddCharge=应付，payAddCharge=应收）
          const hasCostAddChargePermission = this.$checkPermission(['button_Charge_costAddCharge']) // 应付新增权限
          const hasPayAddChargePermission = this.$checkPermission(['button_Charge_payAddCharge']) // 应收新增权限
          const hasAddSpecialChargePermission = this.$checkPermission(['button_Charge_addSpecialCharge']) // 特殊费用新增权限

          // 遍历所有选中的费用进行校验
          for (const charge of chargeList) {
            if (charge.receivable) {
              // 应收费用
              if (charge.special) {
                // 特殊应收费用：需要特殊费用新增权限
                if (!hasAddSpecialChargePermission) {
                  this.$message.warning('没有特殊费用新增权限')
                  return
                }
              } else {
                // 普通应收费用：需要应收新增权限
                if (!hasPayAddChargePermission) {
                  this.$message.warning('没有应收费用新增权限')
                  return
                }
              }
            } else {
              // 应付费用
              if (charge.special) {
                // 特殊应付费用：需要特殊费用新增权限
                if (!hasAddSpecialChargePermission) {
                  this.$message.warning('没有特殊费用新增权限')
                  return
                }
              } else {
                // 普通应付费用：需要应付新增权限
                if (!hasCostAddChargePermission) {
                  this.$message.warning('没有应付费用新增权限')
                  return
                }
              }
            }
          }
        }
      }

      // 调用父组件方法
      this.$emit('selectedCopyChargeHandler', chargeList)
      // CARGO-37588 申请新增费用，添加抄录功能
      if (this.viewSource !== 'ChangeCharge') {
        this.innerVisible = false
      }
    },

    getSelectItems() {
      // 过滤父级节点
      const rows = this.gridApi.getSelectedRows().filter(p => p.chargeItemId)
      const selectItems = []
      for (const charge of rows) {
        selectItems.push(charge)
      }
      return selectItems
    },
    /**
     * 初始化默认条件
     */
    initHandler() {
      this.form.chargeItemId = ''
      this.form.customer = this.job.customerId
      this.form.seCarrier = 0
      this.form.aiCarrier = 0
      this.form.bookingAgent = 0
      this.form.containerLoadType = ''
      this.form.txtServiceLine = ''
      this.form.jobNo = ''
      this.form.containerLoadType = this.isSea ? this.job.containerLoadType : this.job.operateType // 海运 整拼类型 空运 操作模式
      this.form.limit = 30
      this.form.txtSeaLoadingPort = this.job.loadingPortCode
      this.form.txtAirLoadingPort = this.job.loadingPortCode
      this.form.txtSeaDestinationPort = this.job.dischargingPortCode // 海运卸货港
      this.form.txtAirDestinationPort = this.job.destinationPortCode // 空运目的地
      this.form.txtDestAgent = this.job.destinationAgent ? this.job.destinationAgent : ''
      this.form.cargoType = this.job.cargoType
      this.form.receivable = this.receivable
      this.form.accountId = 0
      this.form.eqType = ''
      this.form.eqSize = ''
      this.form.paymentTermMBL = ''
      this.form.poNo = ''
      this.form.saleProductCode = this.job.saleProductCode
      this.form.fullOrInside = this.job.fullOrInside
    },
    /**
     * 重置条件
     */
    resetHandler() {
      this.form.chargeItemId = ''
      this.form.customer = ''
      this.form.seCarrier = 0
      this.form.aiCarrier = 0
      this.form.bookingAgent = 0
      this.form.containerLoadType = ''
      this.form.txtServiceLine = ''
      this.form.jobNo = ''
      this.form.containerLoadType = ''
      this.form.limit = 30
      this.form.txtSeaLoadingPort = ''
      this.form.txtAirLoadingPort = ''
      this.form.txtSeaDestinationPort = ''
      this.form.txtAirDestinationPort = ''
      this.form.txtDestAgent = ''
      this.form.cargoType = ''
      this.form.receivable = ''
      // 主单号
      this.form.mblNo = ''
      this.form.accountId = 0
      this.form.saleProductCode = ''
      this.form.fullOrInside = 0
      // 箱型
      this.form.eqSize = ''
      // 箱种
      this.form.eqType = ''
      // 运费条款
      this.form.paymentTermMBL = ''
      this.form.poNo = ''
    }
  }
}
</script>
<style lang="scss" scoped>
.copy-charge-dialog {
  label {
    font-size: 12px;
    font-weight: normal;
  }
  .el-select {
    width: 100%;
  }
  /deep/.el-form-item__label {
    text-align: right;
  }
}

</style>
